import {Switcher} from "@soinproduction/kit";
import {updateMap} from "./map";
     
document.addEventListener('DOMContentLoaded', () => {
    new Switcher('[data-accordion]', {
        mode: 'accordion',
        default: '1',
        activeClass: 'active',
        attrNav: 'data-id',
        attrContent: 'data-content',
        single: true,
        breakpoint: 1024,
        autoInitNested: true,
        showInfo: false,
    });

    new Switcher('[data-tabs-init]', {
        mode: 'tabs',
        default: '1',
        activeClass: 'active',
        attrNav: 'data-tab',
        attrContent: 'data-tab-content',
        single: true,
        breakpoint: 1024,
        autoInitNested: true,

        onOpen: (id, ctx) => {
            if (ctx.parent.dataset.tabsInit === 'contacts') {
                updateMap(Math.max(0, id - 1));
            }
        },
    });

    (function() {
        const acc = document.querySelector("[data-acc]");
        if (!acc) return;

        const mql = window.matchMedia("(min-width: 768px)");
        let isActive = false;

        function initAccordion() {
            if (!mql.matches) {
                destroyAccordion();
                return;
            }

            if (isActive) return; 
            isActive = true;

            acc.addEventListener("mouseover", onHover, true);
            acc.addEventListener("mouseout", onLeave, true);
        }

        function destroyAccordion() {
            if (!isActive) return;
            isActive = false;

            acc.removeEventListener("mouseover", onHover, true);
            acc.removeEventListener("mouseout", onLeave, true);

            acc.querySelectorAll("[data-item]").forEach(item => {
                item.classList.remove("active");
                const btn = item.querySelector("[data-btn]");
                const content = item.querySelector("[data-content]");
                if (btn) btn.classList.remove("active");
                if (content) {
                    content.classList.remove("active");
                    content.style.maxHeight = "";
                }
            });
        }

        function onHover(e) {
            const item = e.target.closest("[data-item]");
            if (!item || !acc.contains(item)) return;

            const btn = item.querySelector("[data-btn]");
            const content = item.querySelector("[data-content]");

            if (!btn || !content) return;

            acc.querySelectorAll("[data-item]").forEach(el => {
                el.classList.remove("active");
                const b = el.querySelector("[data-btn]");
                const c = el.querySelector("[data-content]");
                if (b) b.classList.remove("active");
                if (c) {
                    c.classList.remove("active");
                    c.style.maxHeight = "";
                }
            });

            item.classList.add("active");
            btn.classList.add("active");
            content.classList.add("active");

            const scrollHeight = content.scrollHeight;
            content.style.maxHeight = scrollHeight + "px";
        }

        function onLeave(e) {
            const item = e.target.closest("[data-item]");
            if (!item || !acc.contains(item)) return;

            const btn = item.querySelector("[data-btn]");
            const content = item.querySelector("[data-content]");
            if (btn) btn.classList.remove("active");
            if (content) {
                content.classList.remove("active");
                content.style.maxHeight = "";
            }
            item.classList.remove("active");
        }

        mql.addEventListener("change", initAccordion);
        initAccordion();
    })();
});





